'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getBetaUser();
  }

  getBetaUser() {
    this.$http.get(`/api/betaUsers/${this.$stateParams.id}`).then(res => {
      this.betauser = res.data;
    });
  }

  save() {
    this.$http.put(`/api/betaUsers/${this.$stateParams.id}`, this.betauser).then(res => {
      this.$state.go('^');
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/betausers/edit/edit.controller.js